import { HubUserAttributesClient } from 'frontend-preferences-client';
export const DISMISSED_YEAR_IN_REVIEW = 'MarketingEmail:dismissedYearInReviews';
const hubUserAttributesClient = HubUserAttributesClient.forCaller('MessagingManagement');
export function fetchUserDismissedYearInReviews() {
  return hubUserAttributesClient.fetch(DISMISSED_YEAR_IN_REVIEW, '');
}
export function updateUserDismissedYearInReviews(value) {
  return hubUserAttributesClient.write(DISMISSED_YEAR_IN_REVIEW, value);
}